const inventoryLevelOptions = [
	{
		value: 1,
		label: '1',
	},
	{
		value: 2,
		label: '2',
	},
];

export { inventoryLevelOptions };



// WEBPACK FOOTER //
// ./src/common/constants/inventoryLevelOptions.js